import React from "react";
import { Box, Snackbar, Typography, useTheme } from "@mui/material";
import MuiAlert, { AlertColor, AlertProps } from "@mui/material/Alert";

interface Props {
  message?: string;
  open: boolean;
  type?: AlertColor;
  handleClose: () => void;
  warningText?: boolean;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={10} ref={ref} variant="filled" {...props} />;
});

const SnackBarToast: React.FC<Props> = (props) => {
  const theme = useTheme();
  return (
    <Box>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={props.open}
        autoHideDuration={5000}
        onClose={props.handleClose}
      >
        <Alert
          onClose={props.handleClose}
          severity={props.type}
          sx={{ width: "100%" }}
        >
          <Typography
            variant="body2"
            color={props.warningText ? theme.palette.error.main : "inherit"}
          >
            {props.message}
          </Typography>
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SnackBarToast;
